var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSciIcon = function SvgSciIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 630 627",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M314.999 626.088C363.485 626.088 402.79 485.933 402.79 313.044C402.79 140.155 363.485 -5.95687e-06 314.999 -3.83748e-06C266.513 -1.7181e-06 227.207 140.155 227.207 313.044C227.207 485.933 266.513 626.088 314.999 626.088Z",
    fill: "url(#paint0_linear_1609_2038)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.637 599.144C335.37 614.629 324.931 621.848 314.999 621.848C305.066 621.848 294.627 614.629 284.36 599.144C274.202 583.824 264.89 561.375 257.003 533.254C241.248 477.073 231.447 399.215 231.447 313.044C231.447 226.873 241.248 149.015 257.003 92.8334C264.89 64.7131 274.202 42.2642 284.36 26.9437C294.627 11.4591 305.066 4.24013 314.999 4.24013C324.931 4.24013 335.37 11.4591 345.637 26.9437C355.795 42.2642 365.108 64.7131 372.994 92.8334C388.75 149.015 398.55 226.873 398.55 313.044C398.55 399.215 388.75 477.073 372.994 533.254C365.108 561.375 355.795 583.824 345.637 599.144ZM402.79 313.044C402.79 485.933 363.485 626.088 314.999 626.088C266.513 626.088 227.207 485.933 227.207 313.044C227.207 140.155 266.513 -1.7181e-06 314.999 -3.83748e-06C363.485 -5.95687e-06 402.79 140.155 402.79 313.044Z",
    fill: "url(#paint1_linear_1609_2038)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M586.104 469.565C610.347 427.575 508.622 323.458 358.896 237.013C209.169 150.569 68.1391 114.531 43.8962 156.521C19.6533 198.511 121.378 302.628 271.104 389.073C420.831 475.517 561.861 511.555 586.104 469.565Z",
    fill: "url(#paint2_linear_1609_2038)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M578.089 429.559C586.366 446.193 587.398 458.843 582.432 467.445C577.466 476.047 565.995 481.478 547.451 482.627C529.104 483.764 505.006 480.604 476.71 473.374C420.178 458.928 347.851 428.486 273.225 385.401C198.598 342.315 136.071 294.899 95.2946 253.163C74.8848 232.273 60.0997 212.984 51.9109 196.527C43.6343 179.893 42.6021 167.243 47.5683 158.641C52.5344 150.039 64.0058 144.608 82.5493 143.459C100.896 142.322 124.994 145.482 153.29 152.712C209.823 167.158 282.149 197.6 356.776 240.686C431.402 283.771 493.929 331.187 534.706 372.923C555.116 393.813 569.901 413.102 578.089 429.559ZM358.896 237.013C508.622 323.458 610.347 427.575 586.104 469.565C561.861 511.555 420.831 475.517 271.104 389.073C121.378 302.628 19.6533 198.511 43.8962 156.521C68.1391 114.531 209.169 150.569 358.896 237.013Z",
    fill: "url(#paint3_linear_1609_2038)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M586.104 156.522C561.861 114.532 420.83 150.569 271.104 237.014C121.377 323.459 19.6526 427.576 43.8956 469.566C68.1385 511.556 209.169 475.518 358.895 389.073C508.622 302.629 610.346 198.512 586.104 156.522Z",
    fill: "url(#paint4_linear_1609_2038)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M547.45 143.46C565.994 144.609 577.465 150.04 582.431 158.642C587.398 167.243 586.365 179.893 578.089 196.527C569.9 212.985 555.115 232.274 534.705 253.164C493.928 294.899 431.402 342.316 356.775 385.401C282.149 428.487 209.822 458.928 153.289 473.374C124.993 480.605 100.896 483.764 82.5487 482.627C64.0052 481.478 52.5338 476.047 47.5676 467.446C42.6015 458.844 43.6337 446.194 51.9102 429.56C60.0991 413.103 74.8842 393.813 95.294 372.923C136.071 331.188 198.597 283.772 273.224 240.686C347.85 197.6 420.177 167.159 476.71 152.713C505.006 145.482 529.103 142.323 547.45 143.46ZM271.104 237.014C420.83 150.569 561.861 114.532 586.104 156.522C610.346 198.512 508.622 302.629 358.895 389.073C209.169 475.518 68.1385 511.556 43.8956 469.566C19.6526 427.576 121.377 323.459 271.104 237.014Z",
    fill: "url(#paint5_linear_1609_2038)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1609_2038",
    x1: 227.207,
    y1: 313.044,
    x2: 402.79,
    y2: 313.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7000FF",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1609_2038",
    x1: 227.207,
    y1: 313.044,
    x2: 402.79,
    y2: 313.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7000FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF5FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1609_2038",
    x1: 271.104,
    y1: 389.073,
    x2: 358.896,
    y2: 237.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7000FF",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1609_2038",
    x1: 271.104,
    y1: 389.073,
    x2: 358.896,
    y2: 237.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7000FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF5FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1609_2038",
    x1: 358.895,
    y1: 389.073,
    x2: 271.104,
    y2: 237.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7000FF",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1609_2038",
    x1: 358.895,
    y1: 389.073,
    x2: 271.104,
    y2: 237.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7000FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF5FF",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSciIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sciIcon.8455e0c6.svg";
export { ForwardRef as ReactComponent };